import { currentUser as getCurrentUser, isAccountAdmin } from 'src/store/session/getters';

export function profile(state, profileData) {
  state.profile = profileData;
}

export function profilePromise(state, promise) {
  state.profilePromise = promise;
}

export function permissions(state, permissionsData) {
  if (permissionsData.permissions) {
    Object.defineProperties(permissionsData.permissions, {
      // add custom permissions to simplify routeGuard OR logic checking
      dashboardFleetOrRentalView: {
        get() {
          return Boolean(this.dashboardFleetView || this.dashboardRentalView);
        },
      },
      isAccountAdmin: {
        get() {
          // pass fake getters object to the isAccountAdmin getter
          return isAccountAdmin(state, { currentUser: getCurrentUser(state) });
        },
      },
      isAllowedToLogin: {
        get() {
          return getCurrentUser(state).isAllowedToLogin();
        },
      },
    });
  }
  state.permissions = permissionsData;
}

export function permissionsPromise(state, promise) {
  state.permissionsPromise = promise;
}

export function ready(state) {
  state.readyResolve();
}

export function setAccount(state, data) {
  state.account = data;
}

export function accountPromise(state, promise) {
  state.accountPromise = promise;
}

export function accounts(state, data) {
  state.accounts = data;
}

export function currentUser(state, user) {
  state.currentUser = user;
}

export function currentUserPromise(state, promise) {
  state.currentUserPromise = promise;
}

export function partner(state, partnerData) {
  state.partner = partnerData;
}

export function partnerPromise(state, promise) {
  state.partnerPromise = promise;
}

export function setCoupon(state, coupon) {
  state.coupon = coupon;
}

export function setCouponLoading(state, isLoading) {
  state.couponLoading = isLoading;
}

export function setBillingErrors(state, billingErrors) {
  state.billingErrors = billingErrors;
}

export function setBillingInfo(state, billingInfo) {
  state.account.billingInfo = billingInfo;
}
